import React from 'react';
import { MapPin, Award, BookOpen, Lightbulb, Rocket, Star } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export const JourneyTimeline = () => {
  const { t } = useLanguage();

  // On récupère les données de contenu depuis les traductions
  const milestonesData = t('journeyTimeline.milestones');

  // Métadonnées non textuelles (icônes + gradients) restent dans le composant
  const meta = [
    {
      icon: MapPin,
      gradient: 'from-purple-600 to-blue-600'
    },
    {
      icon: BookOpen,
      gradient: 'from-blue-600 to-cyan-600'
    },
    {
      icon: Award,
      gradient: 'from-cyan-600 to-teal-600'
    },
    {
      icon: Rocket,
      gradient: 'from-teal-600 to-emerald-600'
    },
    {
      icon: Lightbulb,
      gradient: 'from-emerald-600 to-green-600'
    },
    {
      icon: Star,
      gradient: 'from-orange-500 to-red-600'
    }
  ];

  if (!Array.isArray(milestonesData)) {
    // Si les traductions ne sont pas encore prêtes, on évite de crasher
    return null;
  }

  // Fusion contenu (i18n) + meta (icônes / couleurs)
  const milestones = milestonesData.map((item, index) => {
    const metaItem = meta[index] || meta[0];
    return {
      ...item,
      icon: metaItem.icon,
      gradient: metaItem.gradient
    };
  });

  return (
    <div className="relative">
      {/* Timeline Line */}
      <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-gradient-to-b from-purple-200 via-cyan-200 via-emerald-200 to-orange-200 hidden lg:block" />
      
      {/* Milestones */}
      <div className="space-y-12">
        {milestones.map((milestone, index) => (
          <div key={index} className="relative flex items-start gap-8 group">
            {/* Icon */}
            <div className="relative z-10 flex-shrink-0">
              <div
                className={`w-16 h-16 rounded-full bg-gradient-to-br ${milestone.gradient} flex items-center justify-center shadow-lg group-hover:shadow-2xl group-hover:scale-110 transition-all duration-300`}
              >
                <milestone.icon className="w-8 h-8 text-white" />
              </div>
            </div>
            
            {/* Content */}
            <div className="flex-1 pb-12">
              <div className="bg-white rounded-2xl p-6 lg:p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-slate-200">
                <div className="flex items-center gap-3 mb-3">
                  <span
                    className={`px-3 py-1 rounded-full text-xs font-bold bg-gradient-to-r ${milestone.gradient} text-white`}
                  >
                    {milestone.year}
                  </span>
                  <h3 className="text-xl font-semibold text-slate-900">
                    {milestone.title}
                  </h3>
                </div>
                <p className="text-slate-600 leading-relaxed">
                  {milestone.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
